import { Component, OnInit } from '@angular/core';
import { Entry } from 'contentful';
import { ConfirmedEmailPage } from 'src/app/model/page/group/user/password-reset-success';
import { entraAuthService } from 'src/app/service/auth.service';
import { ContentfulService } from 'src/app/service/contentful.service';
import { SandboxPageStateService } from 'src/app/service/sandbox-page-state.service';
import { ModelValidator } from 'src/app/validator/model-validator';

@Component({
  selector: 'app-password-reset-success',
  templateUrl: './password-reset-success.component.html',
  styleUrls: ['./password-reset-success.component.scss']
})
export class passwordResetSuccessPageComponent implements OnInit {
  confirmedEmailPage: ConfirmedEmailPage = {} as ConfirmedEmailPage;

  constructor(private contentfulService: ContentfulService, private auth: entraAuthService, private sandboxPageStateService: SandboxPageStateService) {}

  ngOnInit(): void {
    const query = { 'fields.title': 'Confirmed Email' };
    this.contentfulService.getPageContentWithEntries(query).then((confirmedEmailPageEntries) => {
      this.mapBanner(confirmedEmailPageEntries);
    });
  }

  private mapBanner(confirmedEmailPageEntries: Entry<any>[]) {
    confirmedEmailPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let imageDetails: any = entry.fields['image'];
    let videoDetails: any = entry.fields['video'];
    this.confirmedEmailPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: imageDetails.fields.file.url as string,
      video: videoDetails?.fields?.file?.url  as string
    };
  }
  public redirectToLogin() {
    this.sandboxPageStateService.clearLocalStorage();
    this.auth.initLogin();
  }
}
